import React, { useState } from 'react'
import { getAPIBaseURL } from '../services/helpers'
import { postDataWithForm } from '../services/request'
import { hasUploadedCv, labelClass } from './employmeProfileUtils'

const CV_ACCEPT =
  '.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'

const CvFileUpload = ({ cvUrl, cvViewUrl, onCvUploaded, disabled = false, optional = true }) => {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')
  const [uploadedFileName, setUploadedFileName] = useState('')
  const [localViewUrl, setLocalViewUrl] = useState('')

  const hasCv = hasUploadedCv(cvUrl)
  const viewUrl = localViewUrl || cvViewUrl

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    setUploading(true)
    setError('')
    const url = `${getAPIBaseURL()}/employme/jobseeker/profile/cv`
    const formData = new FormData()
    formData.append('cv', file)

    const res = await postDataWithForm(url, {}, formData)
    setUploading(false)
    e.target.value = ''

    if (res.error === '' && (res.result?.status === 201 || res.result?.status === 200)) {
      const uploadedUrl = res.result?.data?.data?.cvUrl
      const uploadedViewUrl = res.result?.data?.data?.cvViewUrl
      const fileName = res.result?.data?.data?.fileName || file.name
      setUploadedFileName(fileName)
      setLocalViewUrl(uploadedViewUrl || '')
      onCvUploaded?.(uploadedUrl, uploadedViewUrl)
    } else {
      setError(res.result?.data?.data || 'Failed to upload CV. Please try again.')
    }
  }

  return (
    <div>
      <label className={labelClass}>CV file{optional ? ' (optional)' : ''}</label>

      {hasCv ? (
        <div className="mb-3 flex flex-col gap-2 rounded-xl border border-emerald-200 bg-emerald-50/80 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <p className="text-sm font-medium text-emerald-800">CV uploaded</p>
            {uploadedFileName ? (
              <p className="truncate text-xs text-emerald-700">{uploadedFileName}</p>
            ) : null}
            {!viewUrl ? (
              <p className="mt-1 text-xs text-amber-700">
                Your CV needs to be re-uploaded to view it securely.
              </p>
            ) : null}
          </div>
          {viewUrl ? (
            <a
              href={viewUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex shrink-0 items-center justify-center rounded-lg border border-emerald-200 bg-white px-3 py-1.5 text-xs font-medium text-emerald-700 hover:bg-emerald-50"
            >
              View CV
            </a>
          ) : null}
        </div>
      ) : null}

      <label
        className={`inline-flex cursor-pointer items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 shadow-sm transition-all hover:bg-slate-50 ${
          disabled || uploading ? 'pointer-events-none opacity-60' : ''
        }`}
      >
        {uploading ? 'Uploading...' : hasCv ? 'Replace CV' : 'Choose file'}
        <input
          type="file"
          className="hidden"
          accept={CV_ACCEPT}
          onChange={handleFileChange}
          disabled={disabled || uploading}
        />
      </label>

      <p className="mt-1.5 text-[11px] text-slate-400">PDF, DOC, or DOCX up to 10 MB</p>

      {error ? <p className="mt-2 text-sm text-red-600">{error}</p> : null}
    </div>
  )
}

export default CvFileUpload
